<template>
  <div class="profile_stats_container">
    <h1>{{ getTranslations.home_profile_profile_stats_your_status }}</h1>
    <div class="profile_stats_row">
    <div class="home_stats">
      <p>{{ numberFormatting(userDetails.iqPoints) }}</p>
      <label>{{ getTranslations.home_profile_profile_game_iq }}</label>
    </div>
    <div class="vertical_line_home"></div>
      <div class="home_stats">
      <p>{{ numberFormatting(userDetails.totalPointsEarned) }}</p>
      <label>{{ getTranslations.home_profile_profile_points }}</label>
    </div>
    <div class="vertical_line_home" v-if="hideLeaderboardAndPrizeSection()"></div>
      <div class="home_stats" v-if="hideLeaderboardAndPrizeSection()">
      <p> </p>
      <label>   <router-link to="/home/prizesAndLeaderBoards">{{ getTranslations.home_profile_profile_leaderboard }}</router-link>
      </label>
    </div>
    </div>
    <div class="info_horizontal_line"></div>
    <div class="profile_stats_row">
      <div class="home_stats">
        <p>{{ numberFormatting(userDetails.gamesPlayed) }}</p>
        <label>{{ getTranslations.home_profile_profile_games }}</label>
      </div>
      <div class="vertical_line_home"></div>
      <div class="home_stats">
        <p>{{ numberFormatting(userDetails.achievements) }}</p>
        <label>{{ getTranslations.home_profile_profile_achievements }}</label>
      </div>
      <div class="vertical_line_home"></div>
      <div class="home_stats">
        <p>{{ numberFormatting(userDetails.availableGames) }}</p>
        <label>{{ getTranslations.home_profile_profile_game_unlocked }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  methods: {
    hideLeaderboardAndPrizeSection() {
      return !(this.hideLeaderboard && this.hidePrizeSectionEnabledAtLeaderBoard);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'hideLeaderboard',
      'hidePrizeSectionEnabledAtLeaderBoard',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  ...mapState('game', [
    'playersDetails',
  ]),
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue